import { MAX_DURATION_MINUTES, MIN_DURATION_MINUTES } from "./constants";

export const toDraft = (value: number | null): string =>
  value === null ? "" : String(value);

export const toNumberOrNull = (draft: string): number | null => {
  if (draft === "") return null;

  const parsed = Number.parseInt(draft, 10);

  return Number.isNaN(parsed) ? null : parsed;
};

export const clampDuration = (
  minutes: number,
  min: number = MIN_DURATION_MINUTES,
  max: number = MAX_DURATION_MINUTES,
): number => Math.min(Math.max(minutes, min), max);
